import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              吃瓜热榜
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              实时热度排行，看看本周最火爆的爆料内容
            </p>
          </div>

          <div className="bg-background-100 rounded-2xl overflow-hidden">
            {rankingItems.map((item, idx) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                } hover:bg-background-50/50 transition-colors duration-200 cursor-pointer`}
              >
                <div className={`flex-shrink-0 w-10 h-10 flex items-center justify-center rounded-xl font-heading text-lg ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-800 line-clamp-1">
                    {item.title}
                  </p>
                </div>

                <div className="flex-shrink-0 flex items-center gap-3">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">
                    <i className="ri-fire-line text-accent-500 mr-1"></i>
                    {item.hot}
                  </span>
                  <span className={`text-sm ${
                    item.change === 'up'
                      ? 'text-primary-500'
                      : item.change === 'new'
                      ? 'text-accent-500'
                      : 'text-foreground-400'
                  }`}>
                    {item.change === 'up' ? (
                      <i className="ri-arrow-up-line"></i>
                    ) : item.change === 'new' ? (
                      <i className="ri-sparkling-line"></i>
                    ) : (
                      <i className="ri-arrow-down-line"></i>
                    )}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}